import { apiClient } from 'lib/apiClient';

export function mediaUploadFn(
  api: ReturnType<typeof apiClient>,
) {
  return function fn(fileType: string) {
    if (fileType === 'application/zip') {
      return api.uploadCompressedMedia;
    }

    return api.uploadMedia;
  };
}

export function resumeUploadFn(
  api: ReturnType<typeof apiClient>,
) {
  return function fn(fileType: string) {
    if (fileType !== 'application/pdf') {
      throw new Error('Invalid file type');
    }
    return api.uploadResume;
  };
}
